import { AuthImage } from 'zf-web-components';
import { observer } from 'mobx-react-lite';
import { CONFIG } from 'config';
import styles from './style.module.less';
import type { ReactElement } from 'react';

function AvatarComponent(): ReactElement {
  // const { local } = useContext(RootContext);
  // const logoPath = local.logoPath ?? local.tenant?.tenantLogoPath ?? '';

  // if (local.tenant?.tenantLogoOn === '1' && logoPath.length > 0) {
  //   return (
  //     <AuthImage
  //       preview={false}
  //       src={`${net.redirect(logoPath)}`}
  //       className={styles.avatar}
  //     />
  //   );
  // }

  return (
    <AuthImage
      preview={false}
      src={`${CONFIG.DEFAULT_AVATAR}`}
      className={styles.avatar}
    />
  );
}

export const Avatar = observer(AvatarComponent);
